<template>
  <v-sheet>
    <p>Votre demande a bien été envoyée.</p>

    <p v-if="creation">
      <strong>
        Nous vous rappelons qu'un exemplaire papier des statuts, signé par les
        membres fondateurs, doit être adressé dans les meilleurs délais au
        greffe du tribunal judiciaire ou de proximité (bureau des associations)
        dont dépend la commune où siège l'association.
      </strong>
    </p>

    <p>
      Le tribunal compétent pour traiter votre demande est :<br />
        <strong>
          <div v-html="libelle" />
        </strong>
    </p>
  </v-sheet>
</template>

<script>
export default {
  props: {
    projection: Object,
    mode: {
      type: String,
      default: "creation",
    },
  },
  computed: {
    creation() {
      return "creation" === this.mode;
    },
    libelle() {
      return `${this.tribunal}${this.adresse}${this.complementAdresse}${this.codePostal} ${this.commune}`;
    },
    tribunal() {
      return this.projection.tribunal?.trim() ? `${this.projection.tribunal}<br/>` : "";
    },
    adresse() {
      return this.projection.adresse?.trim() ? `${this.projection.adresse}<br/>` : "";
    },
    complementAdresse() {
      return this.projection.complementAdresse?.trim() ? `${this.projection.complementAdresse}<br/>` : "";
    },
    codePostal() {
      return this.projection.codePostal || "";
    },
    commune() {
      return this.projection.commune || "";
    }
  }
};
</script>
